import { http } from 'viem';
import { FALLBACK_NODE_URL } from './const';

// Moralis usage is paused; go straight to the public Base RPC.
export const baseTransport = () => http(FALLBACK_NODE_URL);
